import React, { useState } from 'react';
import Modal from './Modal';

interface BookingDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  booking: any;
  onSaveNotes: (id: number, notes: string) => void;
}

const BookingDetailsModal: React.FC<BookingDetailsModalProps> = ({ isOpen, onClose, booking, onSaveNotes }) => {
  if (!booking) return null;
  const [notes, setNotes] = useState(booking.adminNotes || '');

  const handleSave = () => {
    onSaveNotes(booking.id, notes);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Booking Details" size="xl">
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-2">
          <div><span className="font-semibold">Court:</span> Court {booking.courtId}</div>
          <div><span className="font-semibold">Date:</span> {booking.date}</div>
          <div><span className="font-semibold">Time:</span> {booking.startTime} - {booking.endTime}</div>
          <div><span className="font-semibold">Status:</span> {booking.status}</div>
          <div className="col-span-2"><span className="font-semibold">User:</span> {booking.userName}</div>
          {booking.firstName && booking.lastName && (
            <div className="col-span-2"><span className="font-semibold">Name:</span> {booking.firstName} {booking.lastName}</div>
          )}
          {booking.email && <div className="col-span-2"><span className="font-semibold">Email:</span> {booking.email}</div>}
          {booking.address && <div className="col-span-2"><span className="font-semibold">Address:</span> {booking.address}</div>}
          {booking.photoUrl && (
            <div className="col-span-2">
              <span className="font-semibold">Receipt:</span>
              <img src={booking.photoUrl} alt="Receipt" className="h-24 w-auto rounded border mt-1" />
            </div>
          )}
        </div>
        <div className="border-t pt-4">
          <label className="block font-semibold mb-1">Admin Notes</label>
          <textarea
            className="w-full border rounded px-3 py-2"
            rows={4}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Add notes, rules, QR code, payment instructions..."
          />
        </div>
        <div className="flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded">Close</button>
          <button onClick={handleSave} className="px-4 py-2 bg-blue-600 text-white rounded">Save Notes</button>
        </div>
      </div>
    </Modal>
  );
};

export default BookingDetailsModal;